import { useEffect, useState } from 'react'
import appRequest from '@apis/app'

const useExam = () => {
  const [exam, setExam] = useState<any>(null)
  const [loading, setLoading] = useState<boolean>(true)
  const [error, setError] = useState<string | null>(null)

  const fetchExam = async () => {
    try {
      const response = await appRequest.getExam()
      setExam(response.data)
    } catch (error: any) {
      setError(error?.message)
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    fetchExam()
  }, [])

  return { exam, loading, error, fetchExam }
}

export default useExam
